import { ConfigStore } from "fs-pb-vue2//store/modules/config";
import { CatalogStore } from "fs-pb-vue2//store/modules/catalog";
import { getModule } from "vuex-module-decorators";
import ICatalogService from "../../services/catalog/ICatalogService";
import { container } from "@/inversify.config";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import IAlertService from "../../services/alert/IAlertService";
import { ChargesVue } from "fs-pb-vue2/vueModels/charges/ChargesVue";
import { OperationRequestData } from "fs-pb-vue2/data/operationRequestData";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import { OperationsApi } from "fs-pb-vue2/services/api/OperationsApi";

/**
 *  Класс для компоненты начислений.
 */
export class ChargesVueGB extends ChargesVue {

  // service:

  /**
 * Сервис каталога
 * @returns {ICatalogService}
 */
  get catalogService(): ICatalogService {
    return container.get<ICatalogService>(DiTokens.CatalogService);
  }

  /**
 * Сервис уведомлений
 * @returns {IAlertService}
 */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  // stores:

  /**
 * Хранилище конфигураций
 * @returns {ConfigStore}
 */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }


  /**
 * Хранилище каталога
 * @returns {CatalogStore}
 */
  get catalogStore(): CatalogStore {
    return getModule(CatalogStore, this.$store);
  }

  // data:
  isDetailView: boolean = false;
  isModalOpen: boolean = false;
  selectedCharge: Record<string, any> = {};


  /** признак загрузки */
  execLoading: boolean = false;

  // watchers:

  // computed:
  // Заголовок
  getCaption(chargeData: any): string {
    if (!chargeData?.Subscription) return "";
    return chargeData.Subscription.Document?.Number?.trim()
      ? chargeData.Subscription?.Document?.Type?.DisplayName || ""
      : chargeData.Subscription.Caption || "";
  }

  // Описание для страницы со списком начислений
  getDescription(chargeData: any): string {
    if (!chargeData?.Subscription) return "";
    const documentNumber = chargeData.Subscription.Document?.Number?.trim();
    return documentNumber
      ? `Номер документа\n${documentNumber}`
      : chargeData.Subscription.Description || "";
  }

  isLastDateVisible(chargeData: any): boolean {
    return chargeData.State == 0 && chargeData.LastExecDate != null;
  }

  getLastExecDate(chargeData: any): string {
    if (!chargeData?.LastExecDate) return "";
    return chargeData.LastExecDate;
  }

  hasActiveDiscount(chargeData: any): boolean {
    if (!chargeData || !chargeData.DiscountDate || !chargeData.DiscountSize) {
      return false;
    }

    const discountDate = new Date(chargeData.DiscountDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return discountDate > today && chargeData.DiscountSize > 0;
  }

  getInnerDescription(chargeData: any): string {
    if (!chargeData?.Subscription?.Document?.Number?.trim()) {
      return chargeData.Subscription?.Description || "";
    }
    const documentName = chargeData.Subscription.Document?.Type?.DisplayName || "";
    const documentNumber = chargeData.Subscription.Document?.Number || "";
    return `Документ\n${documentName}: ${documentNumber}`;
  }

  get hasActiveDiscountFlag(): boolean {
    return this.hasActiveDiscount(this.selectedCharge);
  }

  // methods:
  showDetails(charge: Record<string, any>): void {
    this.selectedCharge = charge;
    this.isDetailView = true;
  }

  backToList(): void {
    this.isDetailView = false;
    this.selectedCharge = {};
  }

  openSubscription(): void {
    this.$router.push({ path: '/subscriptionEdit', query: { openCategorySelect: 'true' } });
  }

  openList(): void {
    this.$router.push('/subscriptionList');
  }

  showCharge(): void {
    this.isModalOpen = true;
  }

  handleNo(): void {
    this.isModalOpen = false;
  }

  handleYes(): void {
    this.isModalOpen = false;
    this.modalSwitch = false;
    this.setChargeVisibility();
    this.backToList();
  }

  hideCharge(): void {
    this.modalSwitch = true;
    this.setChargeVisibility();
  }

  /** перейти к платежу */
  async toPayment(): Promise<void> {
    try {
      this.execLoading = true;
  
      const parser = new DOMParser();
      const document = parser.parseFromString(this.selectedCharge.Data, "application/xml");
      const initDataNode = document.querySelector("Charge > InitData");

      if (!initDataNode) {
        this.alertService.error("Что-то пошло не так. Попробуйте повторить действие позже.");
        return;
      }

      const operationCatId = parseInt(initDataNode.getAttribute("OperationCatId"));
      const initData: Record<string, string> = {};
      initDataNode.childNodes.forEach((propertyNode: ChildNode) => {
        if (propertyNode.nodeType === Node.ELEMENT_NODE) {
          const element = propertyNode as Element;
          const name = element.getAttribute("name");
          const value = element.textContent || "";
          if (name) {
            initData[name] = value;
          }
        }
      });
  
      const addInitData: Array<string> = [];
      for (const [key, value] of Object.entries(initData)) {
        addInitData.push(`${key}=${encodeURIComponent(value)}`);
      }
  
      this.$router.push(
        `/operation/0/${operationCatId}?description=${encodeURIComponent(
          this.selectedCharge.Description || ""
        )}&${addInitData.join("&")}`
      );
    } catch (e) {
      this.alertService.error(e.message);
    } finally {
      this.execLoading = false;
    }
  }

}
